<template>
  <div class="index">
    <template v-if="firstLoading">
      <div class="skeleton_banner"></div>
      <div class="w_sld_react_1210 adv_04_wrap skeleton">
        <div class="floor_title">
          <h2>
            <font>&nbsp;</font>
            <span></span>
            <font>&nbsp;</font>
          </h2>
        </div>
        <div class="floor_goods">
          <div class="item" v-for="(item_main,index_main) in [1,2,3,4,5,6,7,8,9,10]" v-bind:key="index_main">
            <div class="wrap">
              <a href="javascript:void(0)" class="example_text"></a>
              <p class="title">
                <a href="javascript:void(0)">{{item_main}}</a>
              </p>
              <p class="price">
                <span></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <SldDiy v-if="decorateData.data.length" :decorateData="decorateData" @adv19="handleAdv19" />
    <OpenScreen @closeScreen="closeScreen" v-if="show_open_screen" :openScreenData="openScreenData.data"></OpenScreen>
    <!-- 空页面 start-->
    <SldCommonEmpty v-if="!firstLoading&&!decorateData.data.length" totalHeight="900" paddingTop="250"
      :tip="L['我们正在努力装修中，敬请期待～']" />
    <!-- 空页面 end-->

    <template v-if="false">
      <!-- 1 + 1 + 2 商品 start -->
      <div class="diy_block">
        <div class="header flex_row_between_center">
          <div class="left flex_row_start_center">
            <h3>{{L['品牌专区']}}</h3>
            <div class="sub_title">{{L['厂商特供，为消费者甄选天下优品']}}</div>
          </div>
          <div class="right">
            <a href="javascript:void(0);">{{L['更多品牌']}} ></a>
          </div>
        </div>
        <div class="product_three_list flex_row_start_center">
          <template v-for="(item,index) in [
          'https://jbbcimgdev.slodon.cn/images/admin/deco/7XQpTub1S9TqWyOuZtW.jpeg',
          'https://jbbcimgdev.slodon.cn/images/admin/deco/5Y6TmaprBbCQiLJNHhK.jpeg',
          'https://jbbcimgdev.slodon.cn/images/admin/deco/QfDlSfzxdHZMsl261ZB.jpeg']"
          :key="index">
            <div v-if="index < 2" class="product_item row">
              <p class="title">{{L['法意澳直采红酒']}}</p>
              <p class="desc">58{{L['元起']}}</p>
                <div class="product_item_bg" :style="{backgroundImage:'url('+item+')'}"/>
            </div>
            <div v-else class="product_item flex_column_between_center">
              <div class="list">
                <span class="title">{{L['德国']}}NUK</span>
                <span class="desc">31{{L['元起']}} </span>
                <div class="product_item_bg" :style="{backgroundImage:'url('+item+')'}"/>
              </div>
              <div class="list">
                <span class="title">Palladium</span>
                <span class="desc">269{{L['元起']}} </span>
                <div class="product_item_bg" :style="{backgroundImage:'url('+item+')'}"/>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 1 + 1 + 2 商品 end -->

      <!-- 1 + row/2 商品 start -->
      <div class="diy_block">
        <div class="header flex_row_between_center">
          <div class="left flex_row_start_center">
            <h3>{{L['人气推荐']}}</h3>
            <div class="nav_list flex_row_start_center">
              <div class="nav_item active">{{L['编辑推荐']}}</div>
              <div class="nav_item">{{L['热销纵邦']}}</div>
            </div>
          </div>
          <div class="right">
            <a href="javascript:void(0);">{{L['更多推荐']}} ></a>
          </div>
        </div>
        <div class="product_two_list">
          <template v-for="(item,index) in 7" :key="index">
            <div v-if="index == 0" class="product_item first">
              <div class="product_img flex_row_center_center">
                <img src="https://jbbcimgdev.slodon.cn/images/admin/deco/PiIlIXNH6hzgkr1noca.jpg" />
              </div>
              <div class="product_info">
                <p class="product_title">{{L['撕口加热即食，活力早餐帕尼尼']}} 100g</p>
                <p class="price">￥5.8<span>￥15.8</span></p>
              </div>
            </div>
            <div v-else class="product_item flex_column_center_center">
              <div class="product_img flex_row_center_center">
                <img src="https://jbbcimgdev.slodon.cn/images/admin/deco/vbtxmyPT08KjJ1aFkB5.jpeg" />
              </div>
              <div class="product_info">
                <p class="product_title">{{L['3千年种植历史产区，甜糯板栗仁']}} 50{{L['克']}}</p>
                <p class="price">￥6</p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 1 + row/2 商品 end -->

      <!-- link + banner + row/4/商品 start -->
      <div class="diy_block">
        <div class="header flex_row_between_center">
          <div class="left flex_row_start_center">
            <h3>{{L['箱包服饰']}}</h3>
            <div class="sub_list">
              <span v-for="(item,index) in [L['箱包'],L['女装'],L['女鞋'],L['男装'],L['男鞋'],L['运动鞋服']]" :key="index">
                <b v-if="index>0">/</b><a href="javascript:void(0);">{{item}}</a>
              </span>
            </div>
          </div>
          <div class="right">
            <a href="javascript:void(0);">{{L['查看更多']}} ></a>
          </div>
        </div>
        <div class="banner">
          <img src="https://jbbcimgdev.slodon.cn/images/admin/deco/QfDlSfzxdHZMsl261ZB.jpeg" />
        </div>
        <div class="product_four_list flex_row_start_center">
          <div class="product_item" v-for="(item,index) in [
            'https://jbbcimgdev.slodon.cn/images/admin/deco/O0K9wjEPXqSwBykcHXi.jpeg',
            'https://jbbcimgdev.slodon.cn/images/admin/deco/TAeFp6ZcjQwUoCs7PXF.jpeg',
            'https://jbbcimgdev.slodon.cn/images/admin/deco/vbtxmyPT08KjJ1aFkB5.jpeg',
            'https://jbbcimgdev.slodon.cn/images/admin/deco/TAeFp6ZcjQwUoCs7PXF.jpeg']" :key="index">
            <div class="product_img">
              <img :src="item" />
            </div>
            <div class="product_info flex_column_end_center">
              <span v-if="index == 0" class="product_tag hot">{{L['爆款']}}</span>
              <span v-if="index == 2" class="product_tag virtual">{{L['虚拟']}}</span>
              <span class="product_title">{{L['透气蝴蝶扣运动背心']}}</span>
              <span class="product_price">￥89.00</span>
            </div>
          </div>
        </div>
      </div>
      <!-- link + banner + row/4/商品 end -->

      <!-- 4/swiper 商品 start -->
      <div class="diy_block">
        <div class="header flex_row_between_center">
          <div class="left flex_row_start_center">
            <h3>{{L['新品首发']}}</h3>
            <div class="sub_title">{{L['为你寻觅世间好物']}}</div>
          </div>
          <div class="right">
            <a href="javascript:void(0);">{{L['更多品牌']}} ></a>
          </div>
        </div>
        <div class="swiper">
          <el-carousel indicator-position="none" :autoplay="false" :loop="true">
            <el-carousel-item v-for="item in 3" :key="item">
              <div class="swiper_list flex_row_start_center">
                <div v-for="(items,indexs) in [
                  'https://jbbcimgdev.slodon.cn/images/admin/deco/PiIlIXNH6hzgkr1noca.jpg',
                  'https://jbbcimgdev.slodon.cn/images/admin/deco/UmTwFCBpYmOtE6AUPkH.jpg',
                  'https://jbbcimgdev.slodon.cn/images/seller/goods/vG9AvjH1T4VCjy3ryiA.jpg',
                  'https://jbbcimgdev.slodon.cn/images/admin/deco/5Y6TmaprBbCQiLJNHhK.jpeg'
                ]" :key="indexs" class="swiper_item flex_column_between_center">
                  <div class="swiper_imgs">
                    <div class="swiper_img_auto" :style="{backgroundImage:'url('+items+')'}"></div>
                    <div class="swiper_img_hover" :style="{backgroundImage:'url(https://jbbcimgdev.slodon.cn/images/admin/deco/TAeFp6ZcjQwUoCs7PXF.jpeg)'}"></div>
                  </div>
                  <div class="swiper_info flex_column_start_center">
                    <span v-if="indexs == 0" class="swiper_tag hot">{{L['爆款']}}</span>
                    <span v-else-if="indexs == 2" class="swiper_tag virtual">{{L['虚拟']}}</span>
                    <span v-else class="swiper_tag"></span>
                    <p class="swiper_title">{{L['隐形不掉跟，男女同款抑菌多色船袜']}}</p>
                    <p class="swiper_price">￥28.8<span>￥39.9</span></p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 4/swiper 商品 start -->
  </template>
  </div>
</template>
<script>
  import { reactive, getCurrentInstance, ref, onMounted } from "vue";
  import { useRouter, useRoute } from 'vue-router';
  import SldDiy from "../../components/SldDiy";
  import OpenScreen from "../../components/OpenScreen";
  import { useStore } from "vuex";
  import SldCommonEmpty from "../../components/SldCommonEmpty";
  import { getQueryVariable } from '@/utils/common.js'

  export default {
    name: "index",
    components: {
      SldDiy,
      OpenScreen,
      SldCommonEmpty
    },
    setup() {
      const router = useRouter()
      const route = useRoute()
      const adv_21_right_icon = require("../../assets/decorate/right_more_icon.png");
      const adv_24_let_default_pic = require("../../assets/decorate/adv_24_let_default_pic.png");
      const decorateData = reactive({ data: [] }); //装修数据
      const openScreenData = reactive({ data: {} }); //开屏数据
      const firstLoading = ref(true); //是否第一次加载
      const { proxy } = getCurrentInstance();
      const L = proxy.$getCurLanguage();
      const show_open_screen = ref(false);
      const store = useStore();
      const getInitData = () => {
        let param = {}
        if (route.query.type == 'view' && route.query.id) param.decoId = route.query.id
        proxy.$get("v3/system/front/pcDeco/index", param).then(res => {
          firstLoading.value = false;
          if (res.state == 200) {
            if(res.data.data){
              decorateData.data = JSON.parse(res.data.data.replace(/&quot;/g, "\""));
            }
            decorateData.data.map(item => {
              item.json_data = item.json
              if (item.json_data && item.json_data.type == 'adv_19') {
                item.json_data.data.map(child => {
                  child.cur_tab = 0;
                })
              }
              if (item.json_data && item.json_data.type == 'main_banner') {
                item.json_data.data = item.json_data.data.filter(i => i.imgUrl)
              }
            });
          }
        });
      };
      const getOpenScreen = () => {
        proxy.$get("v3/system/front/pcDeco/firstAdv").then(res => {
          if (res.state == 200) {
            openScreenData.data = JSON.parse(res.data.data.replace(/&quot;/g, "\""));
            if (openScreenData.data.imgUrl && openScreenData.data.show_switch && !route.query.type) {
              if (JSON.stringify(store.state.openScreenInfo) == "{}") {
                openScreenData.data.time = new Date().getTime()
                store.commit("updateOpenScreenInfo", openScreenData.data);
                show_open_screen.value = true;
                document.body.style.overflow = "hidden";
              } else if (
                store.state.openScreenInfo.show_radio_sele == openScreenData.data.show_radio_sele
              ) {
                if (store.state.openScreenInfo.show_radio_sele == "one") {
                  if (openScreenData.data.time - new Date().getTime() > 86400) {
                    openScreenData.data.time = new Date().getTime()
                    store.commit("updateOpenScreenInfo", openScreenData.data);
                    show_open_screen.value = true;
                    document.body.style.overflow = "hidden";
                  }
                } else if (store.state.openScreenInfo.show_radio_sele == "more") {
                  store.commit("updateOpenScreenInfo", openScreenData.data);
                  show_open_screen.value = true;
                  document.body.style.overflow = "hidden";
                }
              } else {
                openScreenData.data.time = new Date().getTime()
                store.commit("updateOpenScreenInfo", openScreenData.data);
                show_open_screen.value = true;
                document.body.style.overflow = "hidden";
              }
            }
          }
        });
      };
      const closeScreen = () => {
        show_open_screen.value = false;
        document.body.style.overflow = "";
      };
      router.beforeEach((to, from, next) => {
        document.body.style.overflow = "";
        next()
      })
      getOpenScreen();
      getInitData();
      const handleAdv19 = (data) => {
        let tmp_data = decorateData.data.filter(item => item.dataId == data.dataId)[0];
        tmp_data.json_data.data[data.left_or_right_index]['cur_tab'] = data.tab_index;
      }

      onMounted(() => {

      })

      return {
        adv_21_right_icon,
        adv_24_let_default_pic,
        decorateData,
        firstLoading,
        show_open_screen,
        openScreenData,
        handleAdv19,
        closeScreen,
        L
      };
    }
  };
</script>
<style lang="scss">
.diy_block {
  .swiper {
    .el-carousel__container {
      height: 380px;
    }
  }
}
</style>
<style lang="scss" scoped>
  @import "../../style/decorate.scss";

  .index {
    min-height: 456px;
    padding-bottom: 10px;
  }

  .skeleton_banner {
    width: 100%;
    height: 470px;
    background: $colorSkeleton;
    margin-bottom: 10px;
  }

  .skeleton {
    &.adv_04_wrap .floor_title h2 span {
      background: $colorSkeleton;
      display: inline-block;
      width: 200px;
    }

    &.adv_04_wrap .floor_goods .item .wrap .title {
      background: $colorSkeleton;
      width: 100%;

      a {
        color: transparent;
      }
    }

    &.adv_04_wrap .floor_goods .item .wrap .price {
      width: 100%;
      height: 25px;
    }

    &.adv_04_wrap .floor_goods .item .wrap .price span {
      display: inline-block;
      width: 70px;
      height: 100%;
      background: $colorSkeleton;
    }
  }

  .diy_block {
    width: 1210px;
    background-color: #fff;
    margin: 0 auto;
    overflow: hidden;
    .header {
      height: 56px;
      line-height: 56px;
      margin-top: 10px;
      margin-bottom: 10px;
      padding-left: 14px;
      padding-right: 14px;
      .left {
        h3 {
          font-size: 28px;
          font-weight: 400;
          margin-right: 20px;
          cursor: pointer;
          &:hover {
            color: $colorMain3;
          }
        }
        .nav_list {
          .nav_item {
            position: relative;
            width: 70px;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            text-align: center;
            margin-left: 50px;
            margin-right: 10px;
            cursor: pointer;
            &.active,
            &:hover {
              color: $colorMain3;
            }
            &.active {
              &:after {
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                margin-left: -33px;
                z-index: 9;
                width: 66px;
                height: 2px;
                background: $colorMain3;
              }
            }
          }
        }
        .sub_list {
          font-size: 13px;
          b {
            margin-left: 10px;
            margin-right: 10px;
          }
        }
      }
      .right {}
      a {
        color: #333;
        &:hover {
          color: $colorMain3;
        }
      }
    }
    .banner {
      margin-bottom: 10px;
      img {
        width: 100%;
        cursor: pointer;
      }
    }
    .swiper {
      .swiper_list {
        padding: 10px 20px;
        .swiper_item {
          width: 25%;
          text-align: center;
          cursor: default;
          flex-shrink: 0;
          .swiper_imgs {
            width: 265px;
            height: 265px;
            cursor: pointer;
            .swiper_img_auto,
            .swiper_img_hover {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-size: contain;
            }
            .swiper_img_hover {
              display: none;
            }
          }
          .swiper_info {
            width: 265px;
            height: 91px;
            .swiper_tag {
              display: inline-block;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #fff;
              margin-top: 7px;
              margin-bottom: 2px;
              padding-left: 5px;
              padding-right: 5px;
              &.hot {
                background-color: #E36844;
              }
              &.virtual{
                background-color: #B0CA85;
              }
            }
            .swiper_title {
              width: 150px;
              line-height: 18px;
              margin: 2px auto 4px;
              overflow: hidden;
            }
            .swiper_price {
              margin-bottom: 5px;
              color: $colorMain;
              span {
                color: #999;
                font-size: 12px;
                text-decoration: line-through;
                margin-left: 6px;
              }
            }
          }
          &:hover {
            .swiper_imgs {
              .swiper_img_auto {
                display: none;
              }
              .swiper_img_hover {
                display: block;
              }
            }
            .swiper_info {
              box-shadow: 1px 1px 8px rgb(0 0 0 / 20%);
              background-color: #f4f0ea;
            }
          }
        }
      }
    }
    .product_two_list {
      width: 1210px;
      height: 570px;
      overflow: hidden;
      .product_item {
        float: left;
        width: 240px;
        height: 280px;
        background-color: #fff;
        overflow: hidden;
        margin-left: 20px;
        text-align: center;
        &.first {
          width: 390px;
          height: 570px;
          .product_img {
            width: 390px;
            height: 390px;
            img {
              max-width: 390px;
              max-height: 390px;
            }
          }
          .product_info {
            width: 390px;
            height: 165px;
            line-height: 26px;
            font-size: 18px;
            margin-bottom: 13px;
            .product_title {
              width: 250px;
              line-height: 24px;
              margin-top: 40px;
              margin-bottom: 10px;
              padding: 0;
            }
          }
        }
        .product_img {
          width: 200px;
          height: 200px;
          overflow: hidden;
          cursor: pointer;
          img {
            max-width: 200px;
            max-height: 200px;
            transition: all 1s ease;
          }
        }
        .product_info {
          width: 200px;
          height: 65px;
          border: 1px solid #F4F0EA;
          .product_title {
            width: 150px;
            height: 46px;
            line-height: 18px;
            margin: 0 auto;
            padding-top: 6px;
            padding-bottom: 4px;
            overflow: hidden;
            cursor: pointer;
          }
          .price {
            margin-bottom: 5px;
            color: $colorMain;
            span {
              color: #999;
              font-size: 12px;
              text-decoration: line-through;
              margin-left: 6px;
            }
          }
        }
          &:hover {
            .product_img {
              img {
                transform: scale(1.05);
              }
            }
            .product_info {
              .product_title {
                color: $colorMain3;
              }
            }
          }
      }
    }
    .product_three_list {
      width: 100%;
      height: 320px;
      .product_item {
        position: relative;
        width: 397px;
        height: 320px;

        &.row,
        .list {
          overflow: hidden;
          cursor: pointer;
          transition: all .3s ease;
          &:hover {
            color: #D65A17;
          }
        }
        &.row {
          text-align: center;
          margin-right: 10px;
        }
        .list {
          position: relative;
          width: 397px;
          height: 155px;
          .title {
            width: unset;
            top: 30px;
            left: 20px;
            padding-bottom: 12px;
            &:after {
              left: 0;
              margin-left: 0;
            }
          }
          .desc {
            width: auto;
            top: 86px;
            left: 20px;
          }
        }

        .title,
        .desc {
          width: 397px;
          position: absolute;
          z-index: 9;
        }
        .title {
          top: 48px;
          font-size: 24px;
          padding-bottom: 18px;
          &:after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -22px;
            width: 44px;
            height: 1px;
            background: #666;
          }
        }
        .desc {
          top: 114px;
          color: #4B5459;
          font-size: 14px;
        }

        .product_item_bg {
          position: relative;
          z-index: 1;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          transition: all 1s ease;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
    .product_four_list {
      .product_item {
        text-align: center;
        width: 303px;
        padding-bottom: 10px;
        .product_img {
          width: 303px;
          height: 303px;
          border: 1px solid rgb(244,244,244);
          overflow: hidden;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
            transition: all 1s ease;
            cursor: pointer;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
        .product_info {
          width: 303px;
          height: 84px;
          font-size: 13px;
          .product_tag {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            margin-bottom: 2px;
            padding-left: 5px;
            padding-right: 5px;
            &.hot {
              background-color: #E36844;
            }
            &.virtual{
              background-color: #B0CA85;
            }
          }
          .product_title {
            height: 20px;
            line-height: 20px;
            color: #333;
            font-weight: 700;
            margin-bottom: 3px;
            padding-left: 10px;
            padding-right: 10px;
            cursor: pointer;
          }
          .product_price {
            line-height: 15px;
            color: #d4282d;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
</style>